import { executeGet } from '../common/apiCaller'
import {
  GetLotterySettingsInputDto,
  GetLotterySettingsDto,
} from '../dto/lotterySettingsDto'

const apiName = 'public'
const apiPath = '/lottery-settings'

export const executeGetLotterySettings = async (input: GetLotterySettingsInputDto) => {
  return executeGet<GetLotterySettingsDto>(apiName, `${apiPath}/announcement-datetime`, input)
}